import { createLazyFileRoute } from "@tanstack/react-router";

import { EditTubePage } from "@/features/admin/routes/TubeEdit";

export const Route = createLazyFileRoute("/_auth/admin/tubes/$id/edit")({
  component: () => {
    const params = Route.useParams();
    return <EditTubePage id={params.id} />;
  },
});
